export default function maximumCount(
  value: number,
  maxValue: number = 999,
): string | number {
  if (value > maxValue) {
    return `${maxValue}+`;
  }
  return value;
}
